import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionHomeColumns.module.css';

// The number of columns (numColumns) affects responsive image sizes
const COLUMN_CONFIG = [
  { responsiveImageSizes: '(max-width: 767px) 100vw, 1200px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 600px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 400px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 265px' },
];
const getIndex = numColumns => numColumns - 1;
const getResponsiveImageSizes = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];
  return config ? config.responsiveImageSizes : COLUMN_CONFIG[0].responsiveImageSizes;
};

/**
 * Renders a heading2 title parsing **bold** markdown markers as accent-colored spans.
 * Example CMS content: "Tu clóset tiene **HISTORIAS** que aún no terminan"
 * → "HISTORIAS" renders with css.titleAccent color.
 */
const AccentTitle = ({ data }) => {
  if (!data?.content) return null;
  // Split on **...**  — odd-indexed parts are inside the bold markers
  const parts = data.content.split(/\*\*(.*?)\*\*/g);
  return (
    <h2 className={css.title}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className={css.titleAccent}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </h2>
  );
};

const SectionHomeColumns = props => {
  const {
    sectionId,
    className,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    secondaryCallToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      rootClassName={css.root}
      className={className}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <div className={css.headerRow}>
          <div className={css.titleCol}>
            <AccentTitle data={title} />
          </div>
          <div className={css.metaCol}>
            <Field data={description} className={css.description} options={fieldOptions} />
            <div className={css.ctaRow}>
              <Field data={callToAction} className={css.ctaButton} options={fieldOptions} />
              {secondaryCallToAction ? (
                <Field data={secondaryCallToAction} className={css.ctaSecondary} options={fieldOptions} />
              ) : null}
            </div>
          </div>
        </div>
      ) : null}

      {hasBlocks ? (
        <div
          className={classNames(css.imagesRow, {
            [css.noSidePaddings]: false,
          })}
        >
          <BlockBuilder
            blocks={blocks}
            sectionId={sectionId}
            responsiveImageSizes={getResponsiveImageSizes(numColumns)}
            options={options}
          />
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionHomeColumns;
